import { CueType } from '@rundown-studio/types'

export const getHiddenCueTooltipText = (type: CueType) => {
  if (type === CueType.GROUP) {
    return {
      pdfOnly: 'Group hidden on PDF export (includes all children)',
      csvOnly: 'Group hidden on CSV export (includes all children)',
      both: 'Group hidden on PDF and CSV exports (includes all children)',
    }
  }

  return {
    pdfOnly: 'Hidden on PDF export',
    csvOnly: 'Hidden on CSV export',
    both: 'Hidden on PDF and CSV exports',
  }
}

export const getSkipCueTooltipText = (type: CueType): string => {
  if (type === CueType.GROUP) return 'Group skipped during show (includes all children)'
  return 'Skipped during show'
}

export const getCueTooltipText = (
  type: CueType,
  {
    hideOnPdf,
    hideOnCsv,
    skipDuringShow,
  }: { hideOnPdf?: boolean; hideOnCsv?: boolean; skipDuringShow?: boolean },
): string => {
  const parts: string[] = []

  if (skipDuringShow) parts.push(getSkipCueTooltipText(type))

  if (hideOnCsv && hideOnPdf) {
    parts.push(getHiddenCueTooltipText(type).both)
  } else if (hideOnPdf) {
    parts.push(getHiddenCueTooltipText(type).pdfOnly)
  } else if (hideOnCsv) {
    parts.push(getHiddenCueTooltipText(type).csvOnly)
  }

  return parts.join('. ')
}
